export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/neighborhoods/state.js